import { tv, type VariantProps } from "../../../util/tv";

export const accordionItem = tv({
  slots: {
    base: ["w-full", "p-4", "border rounded-xl"],
    title: ["leading-tight text-display-18"],
    button: [
      "text-left",
      "w-full",
      "flex items-center justify-between",
      "rounded-sm",
      "outline-none",
      "text-gray-20",
    ],
    icon: ["w-6 h-6", "ml-6", "ease-in-out duration-300", "text-gray-500"],
    content: ["overflow-hidden"],
    text: ["text-gray-40"],
  },
  variants: {
    theme: {
      dark: {
        base: ["border-gray-500"],
        title: ["text-white"],
      },
      light: {
        base: ["border-gray-20"],
        title: ["text-white"],
      },
    },
    isExpanded: {
      true: {
        icon: ["rotate-180"],
        text: ["mt-2"],
      },
    },
  },
});

export type AccordionItemVariantProps = VariantProps<typeof accordionItem>;
